const Cleave = require("cleave.js").default;

/**
 * @description Initializes phone field formatters with specified block patterns.
 * @param {string} selector - The jQuery selector for the phone field.
 * @param {Array<number>} blocks - The block pattern for formatting.
 * @param {string} [delimiter] - The delimiter to use between blocks (optional).
 */
function initializeFormatter(selector, blocks, delimiter) {
    const $fields = $(selector);

    if ($fields.length) {
        $fields.each(function () {
            const $field = $(this);
            // Prepare the options for Cleave.js
            const options = { blocks: blocks };
            // Only add delimiters if a delimiter is provided
            if (delimiter !== undefined) {
                options.delimiters = Array(blocks.length - 1).fill(delimiter);
            }
            const cleave = new Cleave($field, options);
            $field.data("cleave", cleave);
        });
    }
}

/**
 * @description Initializes all phone field formatters.
 */
function initPhoneFieldFormatters() {
    initializeFormatter(".formatter--phone-fr-nl", [3, 1, 2, 2, 2, 2]);
    initializeFormatter(".formatter--phone-es-ro", [3, 3, 3, 3]);
    initializeFormatter(".formatter--phone-it-de", [3, 3, 3, 4]);
    initializeFormatter(".formatter--phone-uk", [3, 4, 6]);
    initializeFormatter(".formatter--phone-pt", [4, 2, 7]);
    initializeFormatter(".formatter--phone-be", [3, 3, 2, 2, 2]);
    initializeFormatter(".formatter--phone-at", [3, 1, 7]);
}

function initZipCodeFormatters() {
    initializeFormatter(".formatter--zipcode-nl", [4, 2]);
    initializeFormatter(".formatter--zipcode-pt", [4, 3], '-');
}

function init() {
    initPhoneFieldFormatters();
    initZipCodeFormatters();
}

module.exports = {
    init,
    // semantic symlink
    refresh: init,
    initPhoneFieldFormatters,
    initZipCodeFormatters
};